/**
 * Action Center category order and count aggregation (§8.7). The ordering rule is §9.1's:
 * decisions first, news second — approvals and ownership questions need someone to act; estate
 * changes need someone to know. Extracted so the default-tab choice and badge arithmetic are
 * testable without mounting the three fetching children.
 */

export const ACTION_CENTER_CATEGORIES = [
  { key: "approvals", decision: true },
  { key: "unclaimed", decision: true },
  { key: "changes", decision: false },
];

/**
 * counts: { approvals, unclaimed, changes } — null while a panel has not reported yet.
 * Returns the category the card should open on (first with work, else "changes"), the badge
 * total, and how many of those are decisions (drives the amber attention edge).
 */
export const actionCenterSummary = (counts) => {
  const firstWithWork =
    ACTION_CENTER_CATEGORIES.find((c) => (counts[c.key] ?? 0) > 0)?.key ?? "changes";
  const total = ACTION_CENTER_CATEGORIES.reduce((sum, c) => sum + (counts[c.key] ?? 0), 0);
  const decisionsWaiting = ACTION_CENTER_CATEGORIES.filter((c) => c.decision)
    .reduce((sum, c) => sum + (counts[c.key] ?? 0), 0);
  return { firstWithWork, total, decisionsWaiting };
};
